<template>
  <div class="sw-modal confirm-dialog">
    <div v-click-outside="cancelAction" class="sw-modal-content" v-click.stop>
      <div class="row sw-modal-heading">
        <div class="col">
          <h4>{{ singleSelection ? 'Select File' : 'Select Files' }}</h4>
          <span v-if="singleSelection" class="ml-2 mr-2">Select one file</span>
          <span v-else-if="multipleSelection" class="ml-2 mr-2">Select multiple files</span>
          <span v-else class="ml-2 mr-2">Select one un-tagged file or multiple tagged files</span>
        </div>
      </div>
      <div class="sw-modal-body">
        <div class="row">
          <div class="col-12">
            <template v-if="hasFiles">
              <div v-for="(file, index) in copyOfFiles"
                   v-bind:key="index"
                   class="edit-establishment__images-thumbnail edit-establishment__images-thumbnail--selectable edit-establishment__images-thumbnail--file"
                   v-on:click.stop="select(file.reference)"
              >
                <span v-if="file.roomType" class="edit-establishment__images-thumbnail__tag edit-establishment__images-thumbnail__tag--set">
                    <i class="fas fa-tag"></i>
                </span>
                <img v-if="isImage(file)" v-bind:src="file.url"/>
                <div v-else class="edit-establishment__images-thumbnail__doc">
                  <i class="fas fa-file-image"></i>
                </div>
                <div v-if="!isImage(file)" class="edit-establishment__images-thumbnail-filename">
                  <div>{{file.filename}}</div>
                </div>
                <div v-if="file.selected" class="file-selector__file--selected">
                  <i class="fas fa-paperclip"></i>
                </div>
              </div>
            </template>
            <template v-else>
              <p>You have not uploaded any files to choose from.</p>
              <p>Please upload files first by going to
                <b>Configure Establishments > Files</b> under your profile name.</p>
            </template>
          </div>
        </div>
        <div class="sw-modal-actions">
          <div class="row">
            <div class="col text-center">
              <button class="btn btn-normal" v-on:click.stop="cancelAction()">Cancel</button>
              <button v-if="hasFiles" class="btn btn-primary" v-on:click.stop="selectAction()">Select</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import Vue from 'vue';

    export const SELECTION_MODES = {
        MULTIPLE: 0,
        SINGLE: 1,
        SINGLE_OR_TAGGED: 2
    };

    export const SELECTION_MODE_LABELS = {
        [SELECTION_MODES.MULTIPLE]: 'Select Files',
        [SELECTION_MODES.SINGLE]: 'Select File', 
        [SELECTION_MODES.SINGLE_OR_TAGGED]: 'Select File or Tagged Files'
    };

    export default {
        name: 'FileSelectorDialog',
        components: {
        },
        props: {
            files: Array,
            selectionMode: {
                type: Number,
                default: SELECTION_MODES.MULTIPLE,
                validator: (value) => Object.values(SELECTION_MODES).includes(value)
            }
        },
        data: function() {
            return {
                copyOfFiles: []
            }
        },
        computed: {
            singleSelection: function() {
                return this.selectionMode === SELECTION_MODES.SINGLE;
            },
            multipleSelection: function() {
                return this.selectionMode === SELECTION_MODES.MULTIPLE;
            },
            hasFiles: function() {
                return this.copyOfFiles.length > 0;
            }
        },
        methods: {
            isImage: function(file) {
                if (file.type && file.type.startsWith('image')) {
                    return true;
                } else {
                    return false;
                }
            },
            select: function(reference) {
                let file = this.copyOfFiles.find(f => f.reference === reference);
                console.log('Selected file:', file);
                if (!file) return;

                if (file.selected) {
                    Vue.set(file, 'selected', false);
                    return;
                }

                let selectedFiles = this.copyOfFiles.filter(f => f.selected);
                console.log('Currently selected files:', selectedFiles);

                // Handle different selection modes
                switch (this.selectionMode) {
                    case SELECTION_MODES.SINGLE:
                        // Clear all selections first
                        this.clearAllSelections();
                        Vue.set(file, 'selected', true);
                        console.log('After selection (1), selected files:', this.copyOfFiles.filter(f => f.selected));
                        break;

                    case SELECTION_MODES.SINGLE_OR_TAGGED:
                        
                        if (file.roomType) {
                            // Selecting a tagged file - allow if no non-tagged files selected
                            const hasNonTaggedSelection = selectedFiles.some(f => !f.roomType);
                            if (hasNonTaggedSelection) {
                                this.clearAllSelections();
                            }
                            Vue.set(file, 'selected', true);
                        } else {
                            // Selecting a non-tagged file - clear all selections first
                            this.clearAllSelections();
                            Vue.set(file, 'selected', true);
                        }
                        console.log('After selection (2), selected files:', this.copyOfFiles.filter(f => f.selected));
                        break;

                    case SELECTION_MODES.MULTIPLE:
                    default:
                        Vue.set(file, 'selected', true);
                        console.log('After selection (3), selected files:', this.copyOfFiles.filter(f => f.selected));
                        break;
                }
            },
            clearAllSelections: function() {
                for (let i = 0; i < this.copyOfFiles.length; i++) {
                    Vue.set(this.copyOfFiles[i], 'selected', false);
                }
            },
            cancelAction: function() {
                this.$root.$emit("finished-selecting-files");
            },
            selectAction: function() {
                const selectedFiles = this.copyOfFiles.filter(file => file.selected);
                this.clearAllSelections();
                this.$root.$emit("finished-selecting-files", selectedFiles);
            },
        },
        mounted() {
            this.copyOfFiles = [...this.files];
            this.clearAllSelections();
        }
    }
</script>

<style lang="scss" scoped>
  @import "../../styles/components/_modal.scss";
  @import "../../styles/components/_edit_establishment";
  @import "../../styles/components/_file_selector_dialog.scss";
</style>